/* ============================================================
   FINN-INSPIRED SHOPIFY THEME — theme.js
   ============================================================ */

/* ── CART ── */
function openCart() {
  document.getElementById('cartDrawer').classList.add('open');
  document.getElementById('cartOverlay').classList.add('open');
  document.body.style.overflow = 'hidden';
  refreshCart();
}
function closeCart() {
  document.getElementById('cartDrawer').classList.remove('open');
  document.getElementById('cartOverlay').classList.remove('open');
  document.body.style.overflow = '';
}

function refreshCart() {
  fetch('/cart.js')
    .then(function(r) { return r.json(); })
    .then(function(cart) {
      document.querySelectorAll('.cart-count').forEach(function(el) {
        el.textContent = cart.item_count;
        el.style.display = cart.item_count > 0 ? 'flex' : 'none';
      });
      renderCartDrawer(cart);
    });
}

function renderCartDrawer(cart) {
  var hasItems = cart.items.length > 0;

  // Badge
  var badge = document.getElementById('cartItemBadge');
  if (badge) {
    badge.textContent = cart.item_count + ' item' + (cart.item_count !== 1 ? 's' : '');
    badge.style.display = hasItems ? '' : 'none';
  }

  // Free shipping banner
  var banner = document.getElementById('cartFreeShipBanner');
  if (banner) banner.style.display = hasItems ? 'flex' : 'none';

  // Footer
  var footer = document.getElementById('cartFooter');
  if (footer) footer.style.display = hasItems ? '' : 'none';

  // Subtotal & checkout button
  var priceEl = document.getElementById('cartSubtotalPrice');
  if (priceEl) priceEl.textContent = formatMoney(cart.total_price);
  var checkoutBtn = document.getElementById('cartCheckoutBtn');
  if (checkoutBtn) {
    checkoutBtn.textContent = 'Checkout — ' + formatMoney(cart.total_price) + ' →';
    checkoutBtn.href = '/checkout';
  }

  // Items
  var container = document.getElementById('cartItems');
  if (!container) return;

  if (!hasItems) {
    container.innerHTML = '<div class="cart-empty">'
      + '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" width="52" height="52" style="opacity:.25;margin-bottom:16px"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/></svg>'
      + '<p class="cart-empty-title">Your cart is empty</p>'
      + '<p class="cart-empty-sub">Discover styles you\'ll love</p>'
      + '<a href="/collections/all" onclick="closeCart()" class="btn-primary" style="font-size:14px;padding:12px 28px;margin-top:8px">Shop Now</a>'
      + '</div>';
    return;
  }

  var html = '';
  cart.items.forEach(function(item) {
    html += '<div class="cart-item" data-key="' + item.key + '">'
      + '<a href="' + item.url + '" class="cart-item-img">'
      + (item.image ? '<img src="' + item.image + '" alt="' + (item.product_title || '') + '" loading="lazy">' : '')
      + '</a>'
      + '<div class="cart-item-details">'
      + '<a href="' + item.url + '" class="cart-item-title">' + item.product_title + '</a>'
      + (item.variant_title && item.variant_title !== 'Default Title' ? '<span class="cart-item-variant">' + item.variant_title + '</span>' : '')
      + '<div class="cart-item-price">' + formatMoney(item.final_price) + '</div>'
      + '<div class="cart-qty-control">'
      + '<button onclick="updateCart(\'' + item.key + '\',' + (item.quantity - 1) + ')" class="qty-btn">−</button>'
      + '<span class="qty-num">' + item.quantity + '</span>'
      + '<button onclick="updateCart(\'' + item.key + '\',' + (item.quantity + 1) + ')" class="qty-btn">+</button>'
      + '<button onclick="updateCart(\'' + item.key + '\',0)" class="remove-btn" aria-label="Remove">'
      + '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" width="14" height="14"><polyline points="3 6 5 6 21 6"/><path d="M19 6l-1 14H6L5 6"/><path d="M10 11v6"/><path d="M14 11v6"/><path d="M9 6V4h6v2"/></svg>'
      + '</button>'
      + '</div></div></div>';
  });
  container.innerHTML = html;
}

function renderCartItems(cart) { renderCartDrawer(cart); }

function updateCart(key, quantity) {
  fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: key, quantity: quantity })
  })
  .then(function(r) { return r.json(); })
  .then(function(cart) {
    document.querySelectorAll('.cart-count').forEach(function(el) {
      el.textContent = cart.item_count;
    });
    renderCartItems(cart);
  });
}

function quickAddToCart(event, variantId) {
  event.preventDefault();
  event.stopPropagation();
  var btn = event.target;
  var orig = btn.textContent;
  btn.textContent = '...';
  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: variantId, quantity: 1 })
  })
  .then(function(r) { return r.json(); })
  .then(function() {
    btn.textContent = '✓ Added';
    setTimeout(function() { btn.textContent = orig; }, 1500);
    refreshCart();
    openCart();
  })
  .catch(function() { btn.textContent = orig; });
}

function formatMoney(cents) {
  return '$' + (cents / 100).toFixed(2);
}

/* ── HEADER ── */
function toggleMobileNav() {
  var nav = document.getElementById('mobileNav');
  var btn = document.querySelector('.hamburger');
  if (nav && btn) {
    nav.classList.toggle('open');
    btn.classList.toggle('open');
  }
}

/* ── SHOP DROPDOWN ── */
function toggleShopMenu(event) {
  if (event) event.stopPropagation();
  var dropdown = document.getElementById('shopDropdown');
  var backdrop = document.getElementById('shopBackdrop');
  var btn = document.getElementById('shopBtn');
  if (!dropdown) return;
  var isOpen = dropdown.classList.contains('open');
  if (isOpen) {
    closeShopMenu();
  } else {
    dropdown.classList.add('open');
    dropdown.setAttribute('aria-hidden', 'false');
    if (backdrop) backdrop.classList.add('open');
    if (btn) { btn.classList.add('active'); btn.setAttribute('aria-expanded', 'true'); }
    closeSearch();
  }
}
function closeShopMenu() {
  var dropdown = document.getElementById('shopDropdown');
  var backdrop = document.getElementById('shopBackdrop');
  var btn = document.getElementById('shopBtn');
  if (dropdown) { dropdown.classList.remove('open'); dropdown.setAttribute('aria-hidden', 'true'); }
  if (backdrop) backdrop.classList.remove('open');
  if (btn) { btn.classList.remove('active'); btn.setAttribute('aria-expanded', 'false'); }
}

/* ── LIVE SEARCH ── */
var _searchTimer = null;
var _RECENT_KEY = 'eva_recent_searches';

function toggleSearch() {
  var overlay = document.getElementById('searchOverlay');
  if (!overlay) return;
  overlay.classList.contains('open') ? closeSearch() : openSearch();
}

function openSearch() {
  var overlay = document.getElementById('searchOverlay');
  if (!overlay) return;
  overlay.classList.add('open');
  overlay.setAttribute('aria-hidden', 'false');
  document.body.style.overflow = 'hidden';
  _renderRecentSearches();
  setTimeout(function() {
    var inp = document.getElementById('searchInput');
    if (inp) inp.focus();
  }, 80);
}

function closeSearch() {
  var overlay = document.getElementById('searchOverlay');
  if (!overlay) return;
  overlay.classList.remove('open');
  overlay.setAttribute('aria-hidden', 'true');
  document.body.style.overflow = '';
  var inp = document.getElementById('searchInput');
  if (inp) inp.value = '';
  _resetSearchUI();
}

function clearSearchInput() {
  var inp = document.getElementById('searchInput');
  if (inp) { inp.value = ''; inp.focus(); }
  _resetSearchUI();
}

function _resetSearchUI() {
  _showLoading(false);
  _hide('searchResultsBody');
  var cb = document.getElementById('searchClearBtn');
  if (cb) cb.hidden = true;
  _renderRecentSearches();
  _show('searchPopularSection');
}

function handleSearchInput(inp) {
  var q = inp.value.trim();
  var cb = document.getElementById('searchClearBtn');
  if (cb) cb.hidden = q.length === 0;
  clearTimeout(_searchTimer);
  if (q.length < 2) {
    _resetSearchUI();
    return;
  }
  var rs = document.getElementById('searchRecentSection');
  var ps = document.getElementById('searchPopularSection');
  if (rs) rs.hidden = true;
  if (ps) ps.hidden = true;
  var loading = document.getElementById('searchLoading');
  var body = document.getElementById('searchResultsBody');
  _showLoading(true);
  if (body) body.style.display = 'none';
  _searchTimer = setTimeout(function() { _doSearch(q); }, 280);
}

function handleSearchKeydown(e) {
  if (e.key === 'Escape') { closeSearch(); }
  if (e.key === 'Enter') { submitSearch(e); }
}

function submitSearch(e) {
  if (e) e.preventDefault();
  var inp = document.getElementById('searchInput');
  if (!inp) return;
  var q = inp.value.trim();
  if (!q) return;
  _saveRecent(q);
  window.location.href = '/search?q=' + encodeURIComponent(q) + '&type=product';
}

function _showLoading(show) {
  var el = document.getElementById('searchLoading');
  if (el) el.style.display = show ? 'flex' : 'none';
}

function _doSearch(q) {
  var url = '/search/suggest.json?q=' + encodeURIComponent(q)
    + '&resources[type]=product,collection'
    + '&resources[limit]=8';
  fetch(url)
    .then(function(r) {
      if (!r.ok) throw new Error('HTTP ' + r.status);
      return r.json();
    })
    .then(function(data) {
      var results = (data.resources && data.resources.results) ? data.resources.results : { products: [], collections: [] };
      _renderResults(results, q);
    })
    .catch(function() {
      _showLoading(false);
      var noRes = document.getElementById('searchNoResults');
      var noQ = document.getElementById('searchNoResultsQuery');
      if (noRes) { noRes.style.display = 'flex'; if (noQ) noQ.textContent = q; }
      var body = document.getElementById('searchResultsBody');
      if (body) body.style.display = 'block';
    });
}

function _show(id, displayVal) {
  var el = document.getElementById(id);
  if (el) el.style.display = displayVal || 'block';
}
function _hide(id) {
  var el = document.getElementById(id);
  if (el) el.style.display = 'none';
}

function _renderResults(results, q) {
  var products = results.products || [];
  var collections = results.collections || [];
  var hasAny = products.length > 0 || collections.length > 0;

  _showLoading(false);

  /* Products */
  var prodList = document.getElementById('searchProductsList');
  if (products.length > 0 && prodList) {
    prodList.innerHTML = products.map(function(p) {
      var imgSrc = p.image ? p.image.src.replace(/(\.(jpg|png|webp|gif))(\?.*)?$/, '_120x120$1') : '';
      var img = imgSrc ? '<img src="' + imgSrc + '" alt="' + _esc(p.title) + '" class="sp-img" loading="lazy">' : '<div class="sp-img sp-img-placeholder"></div>';
      var price = p.price ? '$' + (parseInt(p.price) / 100).toFixed(2) : '';
      var compare = (p.compare_at_price && parseInt(p.compare_at_price) > parseInt(p.price))
        ? '<s class="sp-compare">$' + (parseInt(p.compare_at_price) / 100).toFixed(2) + '</s>' : '';
      return '<a href="' + p.url + '" class="sp-item" onclick="_saveRecent(\'' + _esc(q) + '\')">'
        + img
        + '<div class="sp-info">'
        + '<div class="sp-title">' + _highlight(p.title, q) + '</div>'
        + (p.product_type ? '<div class="sp-type">' + p.product_type + '</div>' : '')
        + '</div>'
        + '<div class="sp-price">' + price + compare + '</div>'
        + '</a>';
    }).join('');
    _show('searchProductsSection');
  } else {
    _hide('searchProductsSection');
  }

  /* Collections */
  var colList = document.getElementById('searchCollectionsList');
  if (collections.length > 0 && colList) {
    colList.innerHTML = collections.map(function(c) {
      return '<a href="' + c.url + '" class="search-tag" onclick="_saveRecent(\'' + _esc(q) + '\')">' + _highlight(c.title, q) + '</a>';
    }).join('');
    _show('searchCollectionsSection');
  } else {
    _hide('searchCollectionsSection');
  }

  /* No results */
  if (!hasAny) {
    var noQ = document.getElementById('searchNoResultsQuery');
    if (noQ) noQ.textContent = q;
    _show('searchNoResults', 'flex');
  } else {
    _hide('searchNoResults');
  }

  /* View all */
  if (hasAny) {
    var viewLink = document.getElementById('searchViewAllLink');
    var viewQ = document.getElementById('searchViewAllQuery');
    if (viewLink) viewLink.href = '/search?q=' + encodeURIComponent(q) + '&type=product';
    if (viewQ) viewQ.textContent = q;
    _show('searchFooter');
  } else {
    _hide('searchFooter');
  }

  _show('searchResultsBody');
}

function _highlight(text, q) {
  if (!q) return text;
  var rx = new RegExp('(' + q.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + ')', 'gi');
  return text.replace(rx, '<mark>$1</mark>');
}
function _esc(s) { return String(s).replace(/'/g, "\\'"); }

/* Recent searches */
function _loadRecent() {
  try { return JSON.parse(localStorage.getItem(_RECENT_KEY) || '[]'); } catch(e) { return []; }
}
function _saveRecent(q) {
  if (!q || q.length < 2) return;
  var list = _loadRecent().filter(function(s){ return s !== q; });
  list.unshift(q);
  try { localStorage.setItem(_RECENT_KEY, JSON.stringify(list.slice(0, 6))); } catch(e) {}
}
function removeRecentSearch(q) {
  var list = _loadRecent().filter(function(s){ return s !== q; });
  try { localStorage.setItem(_RECENT_KEY, JSON.stringify(list)); } catch(e) {}
  _renderRecentSearches();
}
function clearAllRecentSearches() {
  try { localStorage.removeItem(_RECENT_KEY); } catch(e) {}
  _renderRecentSearches();
}
function _renderRecentSearches() {
  var list = _loadRecent();
  var sec = document.getElementById('searchRecentSection');
  var container = document.getElementById('recentSearchesList');
  if (!sec || !container) return;
  if (list.length === 0) { sec.hidden = true; return; }
  sec.hidden = false;
  container.innerHTML = list.map(function(s) {
    return '<button class="recent-chip" onclick="fillSearch(\'' + _esc(s) + '\')">'
      + '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="1 4 1 10 7 10"/><path d="M3.51 15a9 9 0 1 0 .49-3.54"/></svg>'
      + s
      + '<span class="recent-chip-x" onclick="event.stopPropagation();removeRecentSearch(\'' + _esc(s) + '\')">×</span>'
      + '</button>';
  }).join('');
}
function fillSearch(q) {
  var inp = document.getElementById('searchInput');
  if (!inp) return;
  inp.value = q;
  handleSearchInput(inp);
  inp.focus();
}

/* Sticky header hide on scroll down */
(function() {
  var lastScroll = 0;
  var header = document.getElementById('siteHeader');
  window.addEventListener('scroll', function() {
    var current = window.pageYOffset;
    if (header) {
      if (current > lastScroll && current > 120) {
        header.style.transform = 'translateY(-100%)';
      } else {
        header.style.transform = 'translateY(0)';
      }
    }
    lastScroll = current;
  }, { passive: true });
})();

/* ── COLLECTION FILTERS ── */
function toggleFilters() {
  var panel = document.getElementById('filterPanel');
  var btn = document.getElementById('filterToggle');
  if (panel) {
    panel.classList.toggle('open');
    if (btn) btn.classList.toggle('active');
  }
}

function toggleFilterGroup(btn) {
  var body = btn.nextElementSibling;
  if (body) body.classList.toggle('open');
  var icon = btn.querySelector('svg');
  if (icon) icon.style.transform = body.classList.contains('open') ? 'rotate(180deg)' : '';
}

function applyFilter(checkbox, paramName, value) {
  var url = new URL(window.location.href);
  var params = url.searchParams;
  if (checkbox.checked) {
    params.append(paramName, value);
  } else {
    var existing = params.getAll(paramName).filter(function(v) { return v !== value; });
    params.delete(paramName);
    existing.forEach(function(v) { params.append(paramName, v); });
  }
  window.location.href = url.toString();
}

function applyPriceFilter() {
  var min = document.getElementById('priceMin');
  var max = document.getElementById('priceMax');
  if (!min || !max) return;
  var url = new URL(window.location.href);
  if (min.value) url.searchParams.set('filter.v.price.gte', min.value);
  if (max.value) url.searchParams.set('filter.v.price.lte', max.value);
  window.location.href = url.toString();
}

function clearFilters() {
  var url = new URL(window.location.href);
  Array.from(url.searchParams.keys())
    .filter(function(k) { return k.startsWith('filter.'); })
    .forEach(function(k) { url.searchParams.delete(k); });
  window.location.href = url.toString();
}

function sortProducts(value) {
  var url = new URL(window.location.href);
  url.searchParams.set('sort_by', value);
  window.location.href = url.toString();
}

/* ── PRODUCT TABS ── */
function switchTab(btn, panelId) {
  document.querySelectorAll('.tab-btn').forEach(function(b) { b.classList.remove('active'); });
  document.querySelectorAll('.tab-panel').forEach(function(p) { p.classList.remove('active'); });
  btn.classList.add('active');
  var panel = document.getElementById(panelId);
  if (panel) panel.classList.add('active');
}

/* ── FAQ ACCORDION ── */
function toggleFaq(btn) {
  var answer = btn.nextElementSibling;
  var icon = btn.querySelector('.faq-icon');
  var isOpen = answer && answer.classList.contains('open');
  document.querySelectorAll('.faq-answer').forEach(function(a) { a.classList.remove('open'); });
  document.querySelectorAll('.faq-icon').forEach(function(i) { i.textContent = '+'; });
  if (!isOpen && answer) {
    answer.classList.add('open');
    if (icon) icon.textContent = '×';
  }
}

/* ── INTERSECTION OBSERVER fade-up ── */
(function() {
  function makeVisible(el) { el.classList.add('visible'); }

  // In Shopify editor, skip animation entirely
  if (window.Shopify && window.Shopify.designMode) {
    document.querySelectorAll('.fade-up').forEach(makeVisible);
    document.addEventListener('shopify:section:load', function() {
      document.querySelectorAll('.fade-up').forEach(makeVisible);
    });
    return;
  }

  if (!('IntersectionObserver' in window)) {
    document.querySelectorAll('.fade-up').forEach(makeVisible);
    return;
  }
  var obs = new IntersectionObserver(function(entries) {
    entries.forEach(function(e) {
      if (e.isIntersecting) {
        makeVisible(e.target);
        obs.unobserve(e.target);
      }
    });
  }, { threshold: 0.06, rootMargin: '0px 0px -20px 0px' });
  document.querySelectorAll('.fade-up').forEach(function(el) { obs.observe(el); });

  // Re-observe when sections added in editor
  document.addEventListener('shopify:section:load', function() {
    document.querySelectorAll('.fade-up:not(.visible)').forEach(function(el) { obs.observe(el); });
  });
})();

/* ── ESCAPE KEY HANDLERS ── */
document.addEventListener('keydown', function(e) {
  if (e.key === 'Escape') {
    closeCart();
    closeSearch();
    closeShopMenu();
    var mobileNav = document.getElementById('mobileNav');
    if (mobileNav) mobileNav.classList.remove('open');
  }
});

/* ── ANNOUNCEMENT BAR countdown if needed ── */
(function() {
  var countdownEl = document.getElementById('announcementCountdown');
  if (!countdownEl) return;
  var target = new Date(countdownEl.dataset.target);
  function update() {
    var diff = target - new Date();
    if (diff <= 0) { countdownEl.textContent = 'ENDED'; return; }
    var h = Math.floor(diff / 3600000);
    var m = Math.floor((diff % 3600000) / 60000);
    var s = Math.floor((diff % 60000) / 1000);
    countdownEl.textContent = h + 'h ' + m + 'm ' + s + 's';
    setTimeout(update, 1000);
  }
  update();
})();

/* ── PRODUCT VARIANT IMAGE SWITCHING ── */
document.addEventListener('DOMContentLoaded', function() {
  // Set sort select to current value
  var sortSelect = document.getElementById('sortSelect');
  if (sortSelect) {
    var urlParams = new URLSearchParams(window.location.search);
    var currentSort = urlParams.get('sort_by');
    if (currentSort) sortSelect.value = currentSort;
  }

  // Cart count initial hide if 0
  document.querySelectorAll('.cart-count').forEach(function(el) {
    if (el.textContent.trim() === '0') el.style.display = 'none';
  });
});
